// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import tippy from 'tippy.js';

export default class UnorderableHandler extends WebComponent {
  didMount() {
    const {
      message,
      skipTo,
    } = this.props;

    let tooltipElement = this.element;
    let stickyHandler = false;

    if (skipTo) {

      this.element.addEventListener('click', () => {
        this.skipToElement = document.querySelector(skipTo);
        if (this.element.closest('.order-container__floating-form-container')) {
          tooltipElement = this.skipToElement;
          stickyHandler = true;
        }

        this.tip = tippy(tooltipElement, {
          arrow: true,
          content: message,
          allowHTML: true,
          theme: 'esp-error',
          placement: 'top',
          trigger: 'manual',
        });

        window.setTimeout(()=> {

          if (stickyHandler) {
            window.scrollTo({
              behavior: 'smooth',
              top:
                this.skipToElement.getBoundingClientRect().top -
                document.body.getBoundingClientRect().top -
                60,
            });
          }

          window.setTimeout(()=> {
            const groups = this.skipToElement.querySelectorAll('.form-group');
            Array.from(groups).forEach(group => {
              if (group.querySelectorAll('input[type=radio]:checked').length == 0) {
                group.classList.add('variant-error');
              }
            });

            this.tip.show();
          },300);

        },100);

      });
    }
    else {
      this.tip = tippy(tooltipElement, {
        arrow: true,
        content: message,
        allowHTML: true,
        theme: 'esp-error',
        placement: 'top',
        trigger: 'click'
      });
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/UnorderableHandler.js